<template>
    <div class="d-flex flex-column" style="gap: var(--space-4)">
        <Field
            label="Address"
            type="text"
            v-model="addressData.address"
            :params="{ placeholder: 'Enter your address' }"
            :required="required"
        />

        <Field
            label="City"
            type="text"
            v-model="addressData.city"
            :params="{ placeholder: 'Enter your city' }"
            :required="required"
        />

        <div
            v-if="provinceCountryRow"
            class="d-flex"
            style="gap: var(--space-4)"
        >
            <div style="flex: 1">
                <Field
                    :key="addressData.country"
                    label="Province/State"
                    type="select"
                    v-model="addressData.province"
                    :params="{
                        options: provinceStateOptions,
                        placeholder: provinceStatePlaceholder,
                        searchable: true,
                    }"
                    :required="!isProvinceReadonly"
                />
            </div>
            <div style="flex: 1">
                <Field
                    label="Country"
                    type="select"
                    v-model="addressData.country"
                    :disabled="lockProvince"
                    :params="{
                        options: 'countries',
                        placeholder: 'Select your country',
                        searchable: true,
                    }"
                    :required="required || countryRequired"
                />
            </div>
        </div>
        <template v-else>
            <Field
                :key="addressData.country"
                label="Province/State"
                type="select"
                v-model="addressData.province"
                :params="{
                    options: provinceStateOptions,
                    placeholder: provinceStatePlaceholder,
                    searchable: true,
                }"
                :disabled="disableCountryProvince || isProvinceReadonly"
                :required="!isProvinceReadonly"
            />

            <Field
                label="Country"
                type="select"
                v-model="addressData.country"
                :disabled="lockProvince || disableCountryProvince"
                :params="{
                    options: 'countries',
                    placeholder: 'Select your country',
                    searchable: true,
                }"
                :required="required || countryRequired"
            />
        </template>
    </div>
</template>

<script>
import Field from '../Field.vue';

export default {
    components: {
        Field,
    },
    props: {
        modelValue: Object, // Expecting an object with address-related fields
        required: {
            type: Boolean,
            default: false,
        },
        countryRequired: {
            type: Boolean,
            default: false,
        },
        lockProvince: {
            type: Boolean,
            default: false,
        },
        disableCountryProvince: {
            type: Boolean,
            default: false,
        },
        provinceCountryRow: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        addressData: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        provinceStateOptions() {
            if (this.addressData.country === 'CA') return 'provinces';
            if (this.addressData.country === 'US') return 'states';
            return [];
        },
        provinceStatePlaceholder() {
            if (this.addressData.country === 'CA')
                return 'Select your province';
            if (this.addressData.country === 'US') return 'Select your state';
            return 'N/A';
        },
        isProvinceReadonly() {
            return !(
                (this.addressData.country === 'CA' && !this.lockProvince) ||
                this.addressData.country === 'US'
            );
        },
    },
    watch: {
        'addressData.country'(newVal, oldVal) {
            // if the country is changed from a valid value to new value or null, clear the province
            if (oldVal != null && newVal !== oldVal) {
                this.addressData.province = '';
            }
        },
    },
};
</script>

<style scoped></style>
